module.exports = __webpack_public_path__ + "img/HOME-10.0bf2349a.png";